import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './resources/styling/GlobalStyles.css'; 
import HomePage from './pages/HomePage/HomePage'; // Import HomePage component
import AboutPage from './pages/AboutPage/AboutPage'; // Import AboutPage component
import ContactPage from './pages/ContactPage/ContactPage'; 
import StyleKZ from './pages/StyleKZPage/StyleKZ';
import Navbar from './components/navbar/Navbar';
import Footer from './components/Footer/Footer';
import Export from './pages/Export/Export';
import Synergy from './pages/SynergyPage/Synergy';
import WhatsAppButton from './components/WhatsappButton/WhatsappButton';



const App = () => {
  return (
    <Router>
      <Navbar /> {/* Add Navbar at the top of the page */}
      <Routes>
        <Route path="/" element={<HomePage />} /> {/* HomePage Route */}
        <Route path="/about" element={<AboutPage />} /> {/* AboutPage Route */}
        <Route path="/contact" element={<ContactPage />} /> {/* ContactPage Route */}
        {/* <Route path="/styleKZ" element={<StyleKZ />} /> StyleKZPage Route */}
        <Route path="/export" element={<Export />} /> {/* ExportPage Route */}
        <Route path="/synergy" element={<Synergy />} /> {/* Synergy Items Route */}

      </Routes>
      <WhatsAppButton />
    </Router>
  );
}

export default App;
